import styled from "@emotion/styled";

export const ReportsFilterTilesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 29px;
`;
